import { render, staticRenderFns } from "./HUDEcommerceCountryProducts.vue?vue&type=template&id=50fcfed6&scoped=true&"
import script from "./HUDEcommerceCountryProducts.vue?vue&type=script&lang=ts&"
export * from "./HUDEcommerceCountryProducts.vue?vue&type=script&lang=ts&"
import style0 from "./HUDEcommerceCountryProducts.vue?vue&type=style&index=0&id=50fcfed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fcfed6",
  null
  
)

export default component.exports